import { Subtitle2, Body2 } from 'ui/theme';
import { LINKED_WORKFLOWS_LABEL_TEST_ID, LINKED_WORKFLOWS_CONTENT_TEST_ID } from './constants';

const displayText = {
  title: 'No linked journeys yet',
  caption:
    'To send contacts from other journeys to this one, add a "Send to Journey" node to those journeys.',
};

export const NoLinkedWorkflowsBanner = () => (
  <>
    <Subtitle2 data-test={LINKED_WORKFLOWS_LABEL_TEST_ID}>{displayText.title}</Subtitle2>
    <Body2 data-test={LINKED_WORKFLOWS_CONTENT_TEST_ID}>{displayText.caption}</Body2>
  </>
);
